import { IonButton, IonCard, IonCardContent, IonInput, IonLabel, IonLoading } from '@ionic/react'
import './reset-pw.scss'
import BasePage from 'pages/base-page/base-page.page'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useState } from 'react'
import { profileService, routeService } from 'services'
import { Redirect } from 'react-router'
import i18next from 'i18n'

const validationSchema = Yup.object().shape({
  id_user: Yup.string().required(i18next.t('form_validator.required')),
  email: Yup.string().email(i18next.t('form_validator.error_mail')).required(i18next.t('form_validator.required')),
})

const ResetPw: React.FC = () => {
  const [loading, setLoading] = useState(false)
  const [redirect, setRedirect] = useState<string | undefined>(undefined)

  const { t } = useTranslation()
  const formik = useFormik({
    initialValues: {
      id_user: '',
      email: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setLoading(true)
      profileService.resetPassword(
        +values.id_user,
        values.email,
        () => {
          setLoading(false)
          setRedirect(routeService.generateRoutePath('/login'))
        },
        () => {
          setLoading(false)
          setRedirect(routeService.generateRoutePath('/error'))
        },
      )
    },
  })

  if (!!redirect) {
    return <Redirect to={redirect}></Redirect>
  }

  return (
    <BasePage pageClass="edisu-page-reset_pw" bgColor="#EDF2F5">
      <IonLoading isOpen={loading} message={t('loading')} />
      <div className="edisu-reset_pw-grid">
        <h2> {t('reset_pw')}</h2>
        <p>
          <b>{t('reset_pw_spid_desc')}</b>
        </p>
        <p>{t('reset_pw_desc')}</p>
        <IonCard className="card">
          <IonCardContent>
            <form onSubmit={formik.handleSubmit} className="container">
              <div className="field">
                <IonLabel className="form-label">{t('id_user')}</IonLabel>
                <IonInput
                  value={formik.values.id_user}
                  onIonInput={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="input"
                  placeholder="Id Utente"
                  name="id_user"
                ></IonInput>
                <IonLabel className={formik.touched.id_user && formik.errors.id_user ? 'form-label-error' : 'hidden'}>
                  {formik.touched.id_user && formik.errors.id_user ? formik.errors.id_user : t('id_user')}
                </IonLabel>
              </div>

              <div className="field">
                <IonLabel className={'form-label'}>{t('mail')}</IonLabel>
                <IonInput
                  value={formik.values.email}
                  onIonInput={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="input"
                  placeholder="Email"
                  name="email"
                ></IonInput>
                <IonLabel className={formik.touched.email && formik.errors.email ? 'form-label-error' : 'hidden'}>
                  {formik.touched.email && formik.errors.email ? formik.errors.email : t('email')}
                </IonLabel>
              </div>

              <div className="buttonUpdate">
                <IonButton type="submit">{t('reset_pw')}</IonButton>
              </div>
            </form>
          </IonCardContent>
        </IonCard>
      </div>
    </BasePage>
  )
}

export default ResetPw
